import { Roles } from "../../models/roles.model";

/** Path a user lands on right after login (and at the "/" index route). */
export const PROVIDER_LANDING_PATH = "/participants/dashboard";
export const DEFAULT_LANDING_PATH = "/home";

/**
 * KAN-2552: everyone except providers lands on the new Home page.
 * Providers keep the participants dashboard — Home is not built for them yet
 * (tracked separately).
 */
export const getLandingPath = (): string =>
	Roles.isProvider() ? PROVIDER_LANDING_PATH : DEFAULT_LANDING_PATH;
